import React, { ReactElement } from 'react';
import { Field } from 'react-final-form';
import FormLabel from 'components/forms/form-label';

/**
 * Form Textarea
 * @param label - input label
 * @param name - input name
 * @param col - label grid col , see tailwind col
 * @param span - input grid span
 * @param type - input type text, number, email
 * @param props - other input props
 * @constructor
 */
const FormTextarea = ({ label = '', rows = 5, name, col = 4, span = 3, type = 'text', ...props }): ReactElement => {
  const field = (
    <Field
      autoComplete="off"
      type={type}
      name={name}
      id={name}
      {...props}
      component="input"
      className="block w-full shadow-sm focus:ring-red-500 focus:border-red-500 sm:max-w-s sm:text-sm border-gray-300 rounded-md"
      placeholder={label}
    >
      {(p) => (
        <>
          <textarea
            rows={rows}
            {...p.input}
            name={p.input.name}
            onChange={p.input.onChange}
            className="block focus:ring-red-500 focus:border-red-500 w-full shadow-sm sm:max-w-s sm:text-sm border-gray-300 rounded-md"
          ></textarea>
        </>
      )}
    </Field>
  );

  if (!label) return field;
  return (
    <>
      <div className={`sm:grid sm:grid-cols-4 sm:gap-${col} sm:items-start`}>
        <FormLabel label={label} />
        <div className={`mt-1 sm:mt-0 sm:col-span-${span}`}>{field}</div>
      </div>
    </>
  );
};

export default FormTextarea;
